import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import MyChartContainer from "./MyChartContainer";
import { Link } from "react-router-dom";
import ScheduleBannerMsg from "../appointments/ScheduleBannerMsg";
import COVIDScreeningModal from "../common/COVIDScreeningModal";
import * as types from "../../constants/actionTypes";
import useQualtrics from "./hooks/useQualtrics";
import useShowQTXSurvey from "./hooks/useShowQTXSurvey";
import SchedulingNoProviders from "./SchedulingNoProviders";
import Spinner from "../common/spinner";

//https://my-tst2.bswhealth.com/scheduling/procedure/2101011111
const Scheduling = (props) => {
    console.info(`Scheduling props`, props);
    const { history, touch, providerListPending } = props;
    const location = window.store.getState().locations;
    const [showQTXSurvey, setShowQTXSurvey] = useState(false);
    const [childFrameData, setChildFrameData] = useState({});
    const bswMatch = ".card.helptip.success";//The match from inside the container to trigger onObserved
    const observe = "div#content"; //the container you are watching for a match
    const enableSurvey = window.serverData.data.enableQualtricsSurveyDirectScheduling;
    //const hideMyChartFluVaccineSchedulingWorkflow = window.serverData.data.hideMyChartFluVaccineSchedulingWorkflow;
    const enableMyChartScreeningMammogramSchedulingWorkflow = window.serverData && window.serverData.data && window.serverData.data.enableMyChartScreeningMammogramSchedulingWorkflow;
    const events = [{ elements: ".card", eventName: "click", message: "childFrameChanged" },
    { elements: ".slot.button", eventName: "click", message: "childFrameChanged" },
    { elements: "a[data-model-id='773']", eventName: "click", message: "Schedule Mammogram" }];//the elements to watch for the specified event on
    let scheduleCampaignReferrer = props.location && props.location.state && props.location.state.scheduleCampaignReferrer;
    let scheduleCampaignActivity = scheduleCampaignReferrer ? { scheduleCampaignReferrer: scheduleCampaignReferrer } : {};
    let locCityAndState = location && location.city && location.state ? location.city + ',' + location.state : "";

    useEffect(() => {
        touch(false);
        logUI("MBHWeb.UI.Scheduling.ComponentDidMount", new Date(), Tools.getURLPath(), scheduleCampaignActivity);
    }, []);

    useEffect(() => {
        const shouldShowQTXSurvey = useShowQTXSurvey(enableSurvey, childFrameData, bswMatch);
        if (shouldShowQTXSurvey) {
            setShowQTXSurvey(true);
            //touch(false);
            logUI("MBHWeb.UI.Scheduling.Completed", new Date(), Tools.getURLPath(), scheduleCampaignActivity);
        }


        return () => { console.info(`Scheduling childFrameData some stupid clean up that does not clean up anything.`); };
    }, [childFrameData]);

    useQualtrics(showQTXSurvey);


    const showCovidModal = props && props.location && props.location.state && props.location.state.showCovidModal ? true : false;

    console.info(`Scheduling has been touched? ${props.touched}`);
    const content = !props.touched ? <React.Fragment>
        <div className="row">
            <div className="col-12 maxWidth-content">
                <div className="mychartDataTile">
                    <div className="mychartDataTile-content">
                        <div className="row">
                            <div className="col-12">
                                <div className="headerwrapper rfvheader">
                                    {/* <h2 className="header">Tell us why you're coming in</h2> */}
                                    {/* <span className="subtle">Choose a provider who matches your specific needs.  If this is an emergency, please contact 911</span> */}
                                </div>
                            </div>
                        </div>
                        <div className="row reason">
                            {enableMyChartScreeningMammogramSchedulingWorkflow && <Link onClick={() => { touch(false); }} to={`/findcare?distance=25&vector=clinicalTerm&keyword=Screening%20Mammogram&location=${locCityAndState}&tab=2`} className="col-12 card " data-workflow-model-id="1246" data-type="rfv" data-model-id="948" data-view-binder-id="">
                                <div>
                                    <span className="header name">Screening Mammogram</span>
                                    <p className="cardline subtle">X-ray picture of the breasts used to check for breast cancer in women.</p>
                                </div>
                            </Link>}
                        </div>
                        <div className="row reason">
                            {enableMyChartScreeningMammogramSchedulingWorkflow && <Link onClick={() => { touch(false); }} to={`/scheduling/procedure/2101011111`} className="col-12 card " data-workflow-model-id="1246" data-type="rfv" data-model-id="951" data-view-binder-id="">
                                <div>
                                    <span className="header name">Flu Shot</span>
                                    <p className="cardline subtle">An immunization given yearly to protect against seasonal influenza.</p>
                                </div>
                            </Link>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </React.Fragment> : "";
    const footer = <React.Fragment>
        <div className="row find-doctor">
            <div className="col-12 maxWidth-content">
                <span>Don't see an option that works for you?  <Link className="find-doctor-text" to={{ pathname: "/findcare" }}>FIND A DOCTOR</Link></span>
            </div>
        </div>
    </React.Fragment>;

    const topBanner = <ScheduleBannerMsg />
    const isNoProviders = props && props.providerList && props.providerList.length == 0 && props.providerListSuccess ? true : false;

    return (
        <>
            {providerListPending ? <Spinner /> : <>
                {isNoProviders ?
                    <SchedulingNoProviders /> :
                    <MyChartContainer mode="scheduling" title="Schedule an Appointment" containerClass="mychart-direct-scheduling-container" footer={footer} content={content} topBanner={topBanner}
                        onMessage={event => { doEventMatch(event, history, locCityAndState, touch); }} events={events} bswMatch={bswMatch} observe={observe} onObserved={(data) => { setChildFrameData(data); }} showQTXSurvey={showQTXSurvey} />}
                {showCovidModal ? <COVIDScreeningModal shouldShowCovidModal /> : null}
            </>
            }
        </>
    );

}
const doEventMatch = (event, history, locCityAndState, touch) => {
    if (event.data.bswElement) {
        const bswElement = event.data.bswElement;
        if (event.data.evt.elements === ".card" && event.data.evt.eventName === "click") {
            console.info('Scheduling doEventMatch card CLICK', event);
            touch(true);
        }
        console.info('Scheduling doEventMatch ', event);
        if (bswElement.outerHTML) {
            let template = document.createElement("template");
            let html = bswElement.outerHTML.trim();
            template.innerHTML = html;
            let clickedElement = template.content.firstChild;
            console.info(`Scheduleing doEventMatch clickedElement`, clickedElement);
            //if (clickedElement.querySelector(`span.header.name`)&&clickedElement.querySelector(`span.header.name`).innerText == 'Screening Mammogram') {
            //    //touch(false);
            //    history.push(`//${window.serverData.data.domain}/findcare?distance=25&vector=clinicalTerm&keyword=Screening%20Mammogram&location=${locCityAndState}&tab=2`);
            //}                
        }
    }
}


const mapStateToProps = (state) => {
    console.info(`Scheduling mapStateToProps state`, state);
    return {
        touched: state.myChartDataTile.touched,
        serverDate: state.session.serverData,
        providerList: state.directScheduling.providerList,
        providerListSuccess: state.directScheduling.providerListSuccess,
        providerListPending: state.directScheduling.providerListPending
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        touch: (isTouched) => dispatch({ type: types.MYCHART_DATA_TILE_TOUCHED, data: { touched: isTouched } })
    }
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Scheduling));
